import {
  InputWithLabelSection,
  FilterLabel,
  CommonImage,
} from "../../styledComponents/common";

import {
  SearchWithButtonContainer,
  SearchWithButtonInput,
  SearchButton,
  ClearSearchButton,
} from "./searchStyles";

import searchIcon from "../../assets/img/icons/search-white.svg";
import crossWhite from "../../assets/img/icons/remove_assignee.svg";
import { useTranslation } from "react-i18next";

const SearchWithButton = (props) => {
  const {
    label,
    itemName,
    searchTermName,
    searchInput,
    onInputChange,
    handleSearch,
    handleClearSearch,
    noLabel,
    margin,
    padding,
    fontSize,
  } = props;

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const { t } = useTranslation();

  return (
    <InputWithLabelSection margin={margin} padding={padding}>
      {!noLabel && (
        <FilterLabel>
          {label ? label : `${t("search")} ${itemName}`}
        </FilterLabel>
      )}
      <SearchWithButtonContainer>
        <SearchWithButtonInput
          value={searchInput}
          onChange={onInputChange}
          onKeyDown={(e) => handleKeyPress(e)}
          placeholder={`${t("search_by")} ${searchTermName}...`}
          fontSize={fontSize}
        />
        {searchInput && (
          <ClearSearchButton onClick={() => handleClearSearch()}>
            <CommonImage src={crossWhite} alt="clear" />
          </ClearSearchButton>
        )}
        <SearchButton onClick={() => handleSearch()}>
          <CommonImage src={searchIcon} alt="search" />
        </SearchButton>
      </SearchWithButtonContainer>
    </InputWithLabelSection>
  );
};

export default SearchWithButton;
